import React, { useState, useEffect } from 'react'


const PluckingRooster = ({ data }) => {
    // --- ESTADOS VISUALES ---
    const [isVisible, setIsVisible] = useState(false);
    const [rankingList, setRankingList] = useState([]);
    const [layoutMode, setLayoutMode] = useState(1); // 1: Vertical, 2: Horizontal
    const [positionOffset, setPositionOffset] = useState(50); // Pixeles

    // --- EFECTO: REACCIONAR A LA DATA DEL PADRE ---
    useEffect(() => {
        if (!data) return;

        // data trae { subtype, data: { ... } }
        const { subtype, data: payload } = data; // Desestructuramos el payload interno

        switch (subtype) {
            case 'show_ranking':
                if (payload) {
                    setRankingList(payload.rankingList || []);
                    // Forzamos true porque es "show"
                    setIsVisible(true);
                }
                break;

            case 'hide_ranking':
                setIsVisible(false);
                break;

            case 'update_data':
                // Solo actualizamos la lista si ya estamos visibles (o preparamos para cuando lo estemos)
                if (payload) {
                    setRankingList(payload.rankingList || []);
                }
                break;

            case 'config_layout':
                if (payload) {
                    if (payload.layoutMode) setLayoutMode(payload.layoutMode);
                    if (payload.positionOffset !== undefined) setPositionOffset(payload.positionOffset);
                }
                break;

            default:
                //console.warn("Subtype desconocido:", subtype);
                break;
        }
    }, [data]);

    
    // Clases dinámicas para SASS
    const containerClass = `rooster-overlay ${isVisible ? 'rooster-overlay--visible' : ''} ${layoutMode === 2 ? 'rooster-overlay--horizontal' : 'rooster-overlay--vertical'}`;
    
    // Estilo dinámico para posición (Offset)
    const positionStyle = layoutMode === 1 
        ? { right: `${positionOffset}px` } // Vertical: Offset es X
        : { bottom: `${positionOffset}px` }; // Horizontal: Offset es Y

    return (
        <>
            <aside className='RankingPluckingRooster__Screen__Ranking__Background'>
                {/* <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='RankingPluckingRooster__Screen__Ranking__Background__Image'/> */}
                <img src='/img/page/backgrounds/background.png' className='RankingPluckingRooster__Screen__Ranking__Background__Image'/>
            </aside>

            <div className={containerClass} style={positionStyle}>
                <div className="rooster-overlay__header">
                    <p className="rooster-overlay__title">Ranking</p>
                </div>

                <div className="rooster-overlay__list">
                    {rankingList.map((player, index) => (
                        (index < 5) && (
                            <div 
                                key={index} 
                                className="rooster-overlay__item" 
                                style={{ animationDelay: `${index * 0.1}s` }} // Cascada de entrada
                            >
                                <div className={`rooster-overlay__rank rank-${index + 1}`}>
                                    #{index + 1}
                                </div>
                                <div className="rooster-overlay__info">
                                    <span className="rooster-overlay__name">{player.fullName}</span>
                                    {/* Opcional: Mostrar tipo de acompañante si quieres */}
                                    {/* <span className="text-xs opacity-70">{player.companionType}</span> */}
                                </div>
                                <div className="rooster-overlay__score">
                                    {player.score} pts
                                </div>
                            </div>
                        )
                    ))}

                    {rankingList.length === 0 && (
                        <div className="rooster-overlay__empty">
                            Esperando resultados...
                        </div>
                    )}
                    <p className='text-center text-white mb-0'>Hecho con ♥ por Five Digital Minds | 2026</p>
                </div>

                <div className='d-flex align-items-center'>
                    <p className='mb-0 fs-2 text-center text-white'>¡Escanea y participa!</p>
                    <img src='/img/page/qr/pluckingrooster-qr-fondo-gris-sin-parametros.png' style={{ width: '210px', marginLeft: 'auto', marginRight: 'auto', marginTop: '6px' }} />
                    <p className='mb-0 fs-2 text-center text-white' style={{ marginLeft: '8px' }}>¡Escanea y participa!</p>
                </div>
            </div>
        </>
    );
};

export { PluckingRooster };